import React, { useState, useEffect, useMemo } from "react";
import styled from "styled-components";
import { debounce } from "lodash";
import {
  SearchFilterContainer,
  SearchFilterProvider,
  SearchFilterGroup,
  SearchFilterOption,
} from "./library/SearchFilter";
import { JobType } from "../apiResources/Job";
import { FilterData } from "./pages/recruiter/applications";

const RecruiterApplicantsFilterBar = (props: Props) => {
  const {
    onQueryChange,
    onFiltersChange,
    filters,
    query: initialQuery,
  } = props;

  const [query, setQuery] = useState(initialQuery);

  const debouncedQueryChange = useMemo(
    () => debounce(onQueryChange, 350),
    [onQueryChange]
  );

  useEffect(() => {
    debouncedQueryChange.cancel();
    debouncedQueryChange(query);
  }, [query, debouncedQueryChange]);

  return (
    <SearchFilterProvider initialValue={filters} onChange={onFiltersChange}>
      <SearchBar id="applicants-filter-bar">
        <SearchInput
          placeholder="Search for a candidate"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
        />

        <SearchFilterContainer>
          <SearchFilterGroup label="Job Type" defaultCollapsed={false}>
            <SearchFilterOption name="type" value={Object.values(JobType)}>
              Select all
            </SearchFilterOption>
            <SearchFilterOption name="type" value={JobType.PERMANENT}>
              Permanent
            </SearchFilterOption>
            <SearchFilterOption name="type" value={JobType.CONTRACT}>
              Contract
            </SearchFilterOption>
          </SearchFilterGroup>

          <SearchFilterGroup label="Status" defaultCollapsed={false}>
            <SearchFilterOption name="hideApplied" value="yes" single>
              Hide applied
            </SearchFilterOption>
          </SearchFilterGroup>
        </SearchFilterContainer>
      </SearchBar>

      {/* <JobListSelectedFilters filters={filters} /> */}
    </SearchFilterProvider>
  );
};

const SearchInput = styled.input`
  flex: 1;
  padding: 0.5rem 1rem;
  border-radius: 3px;
  margin-right: 1rem;
  border: 1px solid ${({ theme }) => theme.colors.gray700};
`;

const SearchBar = styled.div`
  display: flex;
  border-radius: 3px;
  margin-bottom: 1rem;
`;

type Props = {
  onQueryChange: (query: string) => void;
  onFiltersChange: (filters: FilterData) => void;
  query: string;
  filters: FilterData;
};

export default RecruiterApplicantsFilterBar;
